module.exports = __webpack_public_path__ + "img/angular.64260a38.svg";